<template>
    <ul class="towns mb-2 mb-sm-4">
        <div v-for="townList, letter in towns" class="town-group row" :class="selectedTownLetter == letter ? 'd-flex' : 'd-none'" :key="Object.keys(letter)">
            <li v-for="town in townList" :key="town.name" class="town col-sm-6 col-md-3" >
                <a :href="base + town.replace(/\s+/g, '-').toLowerCase()" class="">
                    {{ town }}
                </a>
            </li>
        </div>
    </ul>
</template>

<script>
    export default {
        props: ['towns', 'defaultLetter', 'base'],
        data() {
            return {
                selectedTownLetter: this.defaultLetter
            }
        },
        mounted() {
            this.emitter.on('selectTown', letter => {
                this.selectedTownLetter = letter;
            });
        }
    }
</script>

<style lang="scss" scoped>
    .towns {
        padding-left: 0;
        list-style-type: none;
        .town-group {
            display: none;
        }
        a {
            text-decoration: none;
            &:hover {
                text-decoration: underline !important;
            }
        }
    }
</style>